import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import Spinner from '../../../components/shared/spinner';
import { bookMemberToAppointment } from '../../../actions/appointments';
import CacheService from '../../../services/cacheService';
import viewHelper from '../../../helpers/view';
import CONSTANTS from "../../../constants";

class SignUp extends Component {

    componentDidMount() {
        let appointmentId = this.props.match.params.appointment_id;
        let activityId = this.props.match.params.activity_id;
        this.props.bookMemberToAppointment(appointmentId, activityId, this.props.history);
    }

    getAppointmentInfo(appointment, message) {
        return(
            <div className="content no-margin">
                <div className="col-xs-12 col-md-12 col-lg-12 border-bottom mb-15">
                    <h3 className='text-center'>{message}</h3>
                </div>
                <div className="col-xs-12 col-md-12 col-lg-12 border-bottom">
                    <div className='card-tile'>
                        <div className='card-header'><b>Class at {_.startCase(CacheService.getToken().bname)}</b></div>
                        <div className='card-body'>
                            <h3>
                                {appointment.activity_name}
                                {appointment.class_name ? `: ${appointment.class_name}` : ''}
                                <small>{appointment.class_description ? ` - ${appointment.class_description}` : ''}</small>
                            </h3>
                            {appointment.trainer_name ? <h4>with {appointment.trainer_name}</h4> : ''}
                            <h4>
                                {viewHelper.getFormattedTime(appointment.start_time)} - {viewHelper.getFormattedTime(appointment.end_time)} | {moment(appointment.start_date, CONSTANTS.DATE.FORMAT.DEFAULT).format('ddd, MMMM Do')}
                            </h4>
                            <Link className='btn btn-primary' to={`/${CacheService.getToken().bname}/schedule`}>Book Another</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render () {
        const { appointment } = this.props;
        if (!appointment) {
            return (<Spinner/>);
        } else if (appointment) {
            return this.getAppointmentInfo(appointment, 'You have successfully signed up for class. A confirmation email has been sent.')
        }
    }
}

function mapStateToProps(state) {
    const { appointment } = state;
    return {
        appointment
    };
}

export default connect(mapStateToProps, { bookMemberToAppointment })(SignUp);
